import { createStore, applyMiddleware } from "redux";
import { createLogger } from "redux-logger";
import thunkMiddleware from "redux-thunk";
import rootReducer from "./reducers/rootReducer";

const loggerMiddleware = createLogger();
const middlewares =
  process.env.NODE_ENV === "production"
    ? [thunkMiddleware]
    : [thunkMiddleware, loggerMiddleware];

export default function configureStore(preloadedState) {
  return createStore(
    rootReducer,
    preloadedState,
    applyMiddleware(...middlewares)
  );
}
